import React from 'react';

import styles from './page-wrapper.module.css';

/**
 * Layout component for the page wrapper container
 * @param {*} props
 */
const PageWrapper = props => {
  return (
    <div className={`${styles.pageWrapper} ${props.className}`}>
      {props.children}
    </div>
  );
};

PageWrapper.defaultProps = {
  className: ''
};

export default PageWrapper;
